var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardWind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "34px",
    viewBox: "0 0 40 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "28CD35A7-605B-4AA7-A979-BD758A85312D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-305.000000, -1607.000000)",
    fill: "#FFFFFF",
    id: "icon/wind"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.000000, 1607.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,6 C37.3137085,6 40,8.6862915 40,12 C40,15.3137085 37.3137085,18 34,18 L1,18 C0.44771525,18 2.8967998e-16,17.5522847 0,17 C-6.76353751e-17,16.4477153 0.44771525,16 1,16 L34,16 C36.209139,16 38,14.209139 38,12 C38,9.790861 36.209139,8 34,8 C31.8578046,8 30.1089211,9.68396847 30.0048953,11.8003597 L30,12 C30,12.5522847 29.5522847,13 29,13 C28.4477153,13 28,12.5522847 28,12 C28,8.6862915 30.6862915,6 34,6 Z M20,0 C23.3137085,0 26,2.6862915 26,6 C26,9.3137085 23.3137085,12 20,12 L5,12 C4.44771525,12 4,11.5522847 4,11 C4,10.4477153 4.44771525,10 5,10 L20,10 C22.209139,10 24,8.209139 24,6 C24,3.790861 22.209139,2 20,2 C17.8578046,2 16.1089211,3.68396847 16.0048953,5.80035966 L16,6 C16,6.55228475 15.5522847,7 15,7 C14.4477153,7 14,6.55228475 14,6 C14,2.6862915 16.6862915,0 20,0 Z M11,24 C10.4477153,24 10,23.5522847 10,23 C10,22.4477153 10.4477153,22 11,22 L26,22 C29.3137085,22 32,24.6862915 32,28 C32,31.3137085 29.3137085,34 26,34 C22.6862915,34 20,31.3137085 20,28 L20.0067277,27.8833789 C20.0644928,27.3860402 20.4871642,27 21,27 C21.5522847,27 22,27.4477153 22,28 C22,30.209139 23.790861,32 26,32 C28.209139,32 30,30.209139 30,28 C30,25.790861 28.209139,24 26,24 Z",
    id: "i"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWind);
export default __webpack_public_path__ + "static/media/DashboardWind.4da67f15be6b3be1fe9e86aa0cd171d8.svg";
export { ForwardRef as ReactComponent };